// schema/nodes/doc.ts
var DOC_SCHEMA = () => ({
  content: "block+",
  parseDOM: [
    {
      tag: "node-doc"
    }
  ],
  toDOM: (node) => ["node-doc", 0]
});
var DOC_KEY = "doc";
var DOC = {
  [DOC_KEY]: DOC_SCHEMA
};
export {
  DOC,
  DOC_KEY,
  DOC_SCHEMA
};
